import React from 'react'
import { useEffect } from 'react'
import { Skeleton } from '@mui/material'
import { Card } from '@mui/material'
import { CardActions } from '@mui/material'
import { CardHeader } from '@mui/material'
import { CardContent } from '@mui/material'
import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import { Link } from 'react-router-dom'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import { styled } from '@mui/system'
import { useSetHostServiceNotMineMutation, useSetMineHostServiceMutation } from 'services/hostService'
import { useStartSpyHostServiceMutation, useStopSpyHostServiceMutation } from 'services/propertySpy'
import { useAppDispatch } from 'shared/hooks'
import classNames from 'classnames'

interface HostServiceCardProps {
    hostService: any,
    monitorId?: number,
    onSelectHostServiceForAvailability: (hostService: any) => void
    onStartSpyHostService?: (hostService: any) => void
}

const ParameterLabel = styled('span')({
    fontWeight: '700',
});

export const HostServiceCard = (props: HostServiceCardProps): JSX.Element => {
    const {
        hostService,
        monitorId,
        onSelectHostServiceForAvailability,
        onStartSpyHostService
    } = props

    const [setNotMineHostService] = useSetHostServiceNotMineMutation()
    const dispatch = useAppDispatch()
    const [open, setOpen] = React.useState(false)
    const anchorRef = React.useRef<HTMLButtonElement>(null)
    const [setMineHostService] = useSetMineHostServiceMutation()

    const [startSpyHostService] = useStartSpyHostServiceMutation()
    const [stopSpyHostService] = useStopSpyHostServiceMutation()

    const cardClassNames = classNames(
        {
            isMine: hostService.hostService.isMine,
        }
    );

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: Event | React.SyntheticEvent) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return
        }

        setOpen(false);
    };

    const handleItsMine = async () => {
        setOpen(false);

        if (hostService.hostService.isMine) {
            await setNotMineHostService({
                hostServiceId: hostService.hostService.id
            })

            return
        }

        await setMineHostService({
            hostServiceId: hostService.hostService.id
        })
    }

    const handleStartSpy = async () => {
        await startSpyHostService({
            hostServiceId: hostService.hostService.id,
            marketSpyId: monitorId || 0
        })

        if (onStartSpyHostService !== undefined) {
            onStartSpyHostService(hostService.hostService)
        }       
    }

    const handleStopSpy = async () => {
        await stopSpyHostService({
            hostServiceId: hostService.hostService.id,
            marketSpyId: monitorId || 0
        })      
    }

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    const prevOpen = React.useRef(open);

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [open]);



    const selectHostServiceForAvailability = (hostService: any) => {
        onSelectHostServiceForAvailability(hostService);
        //dispatch(setHostServiceForAvailability(hostService));
    }

    const renderPicture = () => {
        if (hostService.hostService?.strHostservicePictures
            && Array.isArray(hostService.hostService?.strHostservicePictures)
            && hostService.hostService?.strHostservicePictures.length > 0
        ) {
            return (
                <>      
                    <Box sx={
                        {
                            height: '240px',
                            width: '100%',
                            position: 'relative',
                        }
                    }
                    >
                        <Box sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: `100%`
                        }}
                        >
    

                            <Box sx={{ padding: '6px 6px', backgroundColor: '#ffee33', display: 'flex', justifyContent: `space-between`, margin: '6px 6px' }}>
                                <Box sx={{ alignItems: `center`, display: `flex`, fontSize: '20px', fontWeight: 700, color: '#000', minWidth: '150px' }}>
                                        <Box component="span">Position:</Box>
                                        <Box component="span" sx={{ fontWeight: 400, marginLeft: '4px' }}>{hostService.hostService.position ? hostService.hostService.position : ''}</Box>
                                </Box>

                                <Button
                                    color="success"
                                    variant="contained"
                                    sx={{
                                        minWidth: 160,
                                        minHeight: 48,
                                        fontSize: '20px',
                                        textTransform: 'none'
                                    }}
                                    onClick={handleItsMine}
                                >
                                    {hostService.hostService.isMine ? `Not mine` : `Claim it`}
                                </Button >
                             </Box>
                        </Box> 
                        <Box sx={{
                            position: 'absolute', 
                            bottom: 0,
                            right: 0,
                            }}
                        >
                            {
                                hostService.hostService.superHost === true ?
                                    <Box sx={{ fontSize: '20px', padding: '4px 16px', backgroundColor: '#D62424', minWidth: '150px', color: '#FFF' }}>
                                        Super Host
                                    </Box>
                                    : ''
                            }
                            {
                                hostService.hostService.guestFavorite === true ?
                                    <Box sx={{ fontSize: '20px', padding: '4px 16px', backgroundColor: '#56A96D', minWidth: '150px', color: '#FFF' }}>
                                        Guest Favorite
                                    </Box>
                                    : ''
                            }

                            {hostService.mostExpensive ?
                                <Box sx={{ fontSize: '20px', padding: '4px 16px', backgroundColor: '#D62424', minWidth: '150px', color: '#FFF' }}>
                                    Most expensive
                                </Box>
                                : ''
                            }
                            {hostService.theCheapest ?
                                <Box sx={{ fontSize: '20px', padding: '4px 16px', backgroundColor: '#56A96D', minWidth: '150px', color: '#FFF' }}>
                                    Least expensive
                                </Box>
                                : ''
                            }
                        </Box>                 
                            <Box
                                component="img"
                                sx={{
                                    height: '100%',
                                    width: '100%',
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'cover'
                                }}
                                alt="The house from the offer."
                                src={hostService?.hostService?.strHostservicePictures[0].url}>
                            </Box>
                    </Box>
                </>
            )
        } else {
            return (
                <>
                    <Skeleton variant="rounded" width={270} height={250} animation={false} />
                </>
            )
        }
    }

    const getAvailableValue = (hostService: any): string => {
        if (hostService === undefined || hostService.wasFoundByTheMonitor === undefined || hostService.overallRuns === undefined) {
            return '';
        }
        const percent: number = hostService.wasFoundByTheMonitor / hostService.overallRuns * 100;

        return `${hostService.wasFoundByTheMonitor} of ${hostService.overallRuns} days (${percent.toFixed(0)}%)`
    }

    const getOccupiedValue = (hostService: any): string => {
        if (hostService === undefined || hostService.wasFoundByTheMonitor === undefined || hostService.overallRuns === undefined) {
            return '';
        }

        const occupied = hostService.overallRuns - hostService.wasFoundByTheMonitor;
        const percent: number = (occupied / hostService.overallRuns) * 100;
        return `${occupied} of ${hostService.overallRuns} days (${percent.toFixed(0)}%)`
    }

    const propertyListContainer = {
        padding: '20px 10px',
        gridTemplateColumns: 'max-content max-content',
        display: 'grid',

    }

    const namePropStyle = {
        fontWeight: '700',
        fontSize: '20px',
        margin: '0 0 6px 4px',
    }

    const valuePropStyle = {
        margin: '0 0 6px 4px',
        fontSize: '20px'
    }

    const renderPropSpyButton = (hostService: any) => {
        if (hostService.propSpy === true) {
            return (
                <Button
                    color="success"
                    variant="outlined"
                    onClick={handleStopSpy}
                    sx={{
                        minWidth: 160,
                        minHeight: 48,
                        fontSize: '20px',
                        textTransform: 'none',
                        borderWidth: '2px!important',
                        background: `#FFFF`
                    }}
                >
                    Stop spy
                </Button >
            )
        }

        return (
            <Button
            color="success"
            variant="outlined"
            onClick={handleStartSpy}
            sx={{
                minWidth: 160,
                minHeight: 48,
                fontSize: '20px',
                textTransform: 'none',
                borderWidth: '2px!important',
                background: `#FFFF`
            }}
        >
            Spy it
            </Button >
        )
    }

    return (
        <>
            <Card className={cardClassNames} sx={{
                maxWidth: 420,
                minWidth: 420,
                minHeight: 834,
                '& .MuiCardHeader-root': {
                    padding: '16px 16px 0 16px',
                },
                '& .MuiCardHeader-content': {
                    padding: '0 0 0 0',
                },
                '&.isMine': {
                    color: '#FFF',
                },
                '&.isMine .MuiCardHeader-root': {
                    backgroundColor: '#1e1e1e',
                },
                '&.isMine .MuiCardContent-root': {
                    backgroundColor: '#1e1e1e',
                },
                '&.isMine .MuiList-root': {
                    backgroundColor: '#1e1e1e',
                },
                '&.isMine .MuiCardActions-root': {
                    backgroundColor: '#1e1e1e',
                },
                '&.isMine .MuiSvgIcon-root': {
                    color: '#FFF'
                },             
                  
            }}>
                <CardHeader

                    title={
                        <Box sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            height: '48px',
                            maxHeight: '48px',
                            fontWeight: '600', fontSize: '18px', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical',
                            wordBreak: `break-all`
                        }}>
                            {hostService?.hostService.name}
                        </Box>
                    }
                />

                <CardContent sx={{ p: 0 }}>
                    <List sx={{ width: '100%', maxWidth: 420, bgcolor: 'background.paper', py: '6px' }}>
                        <ListItem key="picture">
                            {
                                renderPicture()
                            }
                        </ListItem>
                    </List>
                    <Box sx={propertyListContainer}>
                        <Box sx={namePropStyle}>
                            City:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {
                                `${hostService?.hostService && hostService?.hostService.city}`
                            }
                        </Box>
                        <Box sx={namePropStyle}>
                            Bedrooms:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {
                                hostService?.hostService.bedrooms
                            }
                        </Box>
                        <Box sx={namePropStyle}>
                            Beds:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {
                                hostService?.hostService.beds
                            }
                        </Box>
                        <Box sx={namePropStyle}>
                            Pets:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {
                                hostService?.hostService.pets
                            }
                        </Box>
                        <Box sx={namePropStyle}>
                            Rating:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {
                                hostService?.hostService.rating
                            }
                        </Box>
                        <Box sx={namePropStyle}>
                            Reviews:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {
                                hostService?.hostService.ratingsCount
                            }
                        </Box>
                        <Box sx={namePropStyle}>
                            Available:
                        </Box>
                        <Box sx={valuePropStyle}>
                            <Typography
                                component="span"
                                sx={{
                                    cursor: 'pointer',
                                    color: '#1976d2',
                                }}
                                onClick={() => selectHostServiceForAvailability(hostService?.hostService)}>
                                {getAvailableValue(hostService)}
                            </Typography>
                        </Box>
                        <Box sx={namePropStyle}>
                            Occupied:
                        </Box>
                        <Box sx={valuePropStyle}>
                            <Typography
                                component="span"
                                sx={{
                                    cursor: 'pointer',
                                    color: '#1976d2',
                                }}
                                onClick={() => selectHostServiceForAvailability(hostService?.hostService)}>
                                {getOccupiedValue(hostService)}
                            </Typography>
                        </Box>
                        <Box sx={namePropStyle}>
                            Original price:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {`$${hostService?.originalPrice}`}
                        </Box>
                        <Box sx={namePropStyle}>
                            Discounted price:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {hostService?.discountedPrice === null ? '' : `$${hostService?.discountedPrice}`}
                        </Box>
                        <Box sx={namePropStyle}>
                            Price:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {`$${hostService?.priceTotal}`}
                        </Box>
                        <Box sx={namePropStyle}>
                            Description:
                        </Box>
                        <Box sx={valuePropStyle}>
                            {`${hostService?.description ? hostService?.description : ''}`}
                        </Box>
                    </Box>
                </CardContent>
                <CardActions sx={{ p: 0 }}>
                    <Box sx={{ width: '100%' }}>
                        <Divider variant="middle" sx={{ m: 0, borderBottomWidth: 1, bgcolor: (theme) => theme.palette.divider }} />
                        <Stack direction="row" spacing={''} sx={{ p: '8px', justifyContent: "space-between", }}>
                            <Link to={`/hostservice/${hostService.hostService.id}?monitoridforprices=${monitorId}`}>
                                <Button
                                    color="success"
                                    variant="contained"
                                    sx={{
                                        minWidth: 160,
                                        minHeight: 48,
                                        fontSize: '20px',
                                        textTransform: 'none'
                                    }}
                                >
                                    Details
                                </Button >
                            </Link>
                            {
                                renderPropSpyButton(hostService?.hostService)
                            }

                        </Stack>
                    </Box>
                </CardActions>
            </Card>

            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    autoFocusItem={open}
                                    id="composition-menu"
                                    aria-labelledby="composition-button"
                                    onKeyDown={handleListKeyDown}
                                >
                                    <MenuItem key="itsmine" onClick={handleItsMine}>Claim it</MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>

    )
}